export default "__VITE_ASSET__ByPkPoec__"